(function () {
  const buttons = document.querySelectorAll(
    ".green-button, .green-button-image, .image-with-text-button, .image-with-text-button-visit, .footer__button"
  );

  buttons.forEach((button) => {
    ["mouseenter", "mouseout"].forEach((evt) => {
      button.addEventListener(evt, (e) => {
        let parentOffset = button.getBoundingClientRect(),
          relX = e.clientX - parentOffset.left,
          relY = e.clientY - parentOffset.top;

        const span = button.querySelector("span");

        if (span) {
          span.style.top = relY + "px";
          span.style.left = relX + "px";
        }
      });
    });
  });
})();
